var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "15px",
    viewBox: "0 0 24 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Error-Screen-2",
    transform: "translate(-295.000000, -317.000000)",
    fill: "#252C3B",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8673357_ic_fluent_eye_show_filled_icon",
    transform: "translate(295.000000, 317.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,4.805544 C14.65092,4.805544 16.8,6.9546 16.8,9.60552 C16.8,12.25656 14.65092,14.40552 12,14.40552 C9.349032,14.40552 7.2,12.25656 7.2,9.60552 C7.2,6.9546 9.349032,4.805544 12,4.805544 Z M12,0.6 C17.5362,0.6 22.31532,4.380012 23.64132,9.67728 C23.76204,10.15944 23.469,10.6482 22.98684,10.76892 C22.50468,10.88952 22.01592,10.5966 21.8952,10.11432 C20.76852,5.613552 16.70568,2.4 12,2.4 C7.292316,2.4 3.228108,5.616312 2.10342,10.11984 C1.982988,10.602 1.49442,10.89528 1.012176,10.77492 C0.529932,10.65444 0.236628,10.16592 0.35706,9.68364 C1.680768,4.383264 6.461376,0.6 12,0.6 Z",
    id: "Shape"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/show.87ea0411af523d48b26b0608b2a834ef.svg";
export { ForwardRef as ReactComponent };